<template>
    <modal name="product-list-modal" class="offline-review-modal"
           :width="'80%'"
           :height="'80%'"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <div class="list-content pa15">
            <board-list-component :boardType="'productSelect'"></board-list-component>
            <div class="btn_wrap text-center">
                <el-button type="cancel" @click="close">닫기</el-button>
            </div>
        </div>
    </modal>
</template>


<script>
import BoardListComponent from "@/components/board/BoardListComponent";
import EventBus from "@/utils/event-bus";

export default {
    name: "ProductListModal",
    mixins: [],
    components: {
        BoardListComponent
    },
    provide() {
        return {
            'productListSelectAfter': this.productListSelectAfter,
        }
    },
    props: {
    },
    data() {
        return {
            path :'',
        }
    },
    beforeRouterEnter() {},
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
    },
    methods:{
        handlerBeforeOpen(event) {
            this.path = this.$route.fullPath
        },
        handlerOpened() {
        },
        handlerBeforeClose() {
            if(this.path !=  this.$route.fullPath) {
                this.$router.replace(this.path);
            }
            
        },
        close(){
            this.$modal.hide('product-list-modal');
        },
        productListSelectAfter(productData) {
            EventBus.$emit('productListSelectAfter',productData);
            this.close();
        },
    },
    watch: {

    },
}
</script>

<style scoped>

</style>
